export var DEFAULT_FILE_LABEL = 'Menu';
export var TYPE_PDF = 'pdf';